import { useState } from "react";
import { createUser } from "../api/users";

const ROLE_OPTIONS = [
  { value: "viewer", label: "Viewer - read-only" },
  { value: "tech", label: "Tech - manage & provision devices" },
  { value: "admin", label: "Admin - manage users & config" },
];

// Admin-only form for creating additional accounts.
export default function SignupForm({ onSuccess }) {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [role, setRole] = useState("tech");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const user = await createUser({ email, password, full_name: fullName || null, role });
      setSuccess(`Account created for ${user.email} (role: ${user.role}).`);
      setFullName("");
      setEmail("");
      setPassword("");
      setConfirm("");
      setRole("tech");
      if (onSuccess) onSuccess(user);
    } catch (err) {
      setError(err.message || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="field">
        <label htmlFor="su-name">Full name</label>
        <input
          id="su-name"
          className="input"
          type="text"
          placeholder="Jane Doe"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
      </div>

      <div className="field">
        <label htmlFor="su-email">Email</label>
        <input
          id="su-email"
          className="input"
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label htmlFor="su-role">Role</label>
        <select
          id="su-role"
          className="input"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          {ROLE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="field">
        <label htmlFor="su-pass">Password</label>
        <input
          id="su-pass"
          className="input"
          type="password"
          placeholder="At least 8 characters"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
      </div>

      <div className="field">
        <label htmlFor="su-confirm">Confirm password</label>
        <input
          id="su-confirm"
          className="input"
          type="password"
          placeholder="Repeat password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
          required
        />
      </div>

      <button
        type="submit"
        className="btn btn-primary btn-block"
        disabled={loading}
        style={{ marginTop: 8 }}
      >
        {loading ? "Creating account…" : "Create account"}
      </button>
    </form>
  );
}
